<template>
  <div>
    <b-row>
      <b-table striped hover :fields="fields" :items="items">
        <!-- Optional default data cell scoped slot -->
        <template #cell()="data">
          <i>{{ data.value }}</i>
        </template>
        <template v-slot:cell(actions)="data">
          <b-dropdown text="Actions">
            <b-dropdown-item @click="create(items[data.index])">
              Create
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-row>
  </div>
</template>

<script>
import {ACTIONS, CORE_PREFIX} from "@/store/constants";
import {yoyoHttp} from "@/services/http.service";

export default {
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: "status", label: "Status", sortable: false},
        { key: 'actions', label: 'Actions' }
      ],
      items: [
      ]
    };
  },
  mounted() {
    let shotFileId = this.$route.query.id;
    this.fetchShotFileShipments(shotFileId);
    this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
  },
  methods: {
    fetchShotFileShipments(id) {
      //Fetch shot file shipments
      yoyoHttp.get('api/ShotFile/ListShipments/' + id)
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    create(item) {
      //Redirect to create shipment page with query params
      this.$router.push('/CreateShipment?id='+ item.id + '&shotFileShipment=true');
    }
  }
};
</script>
<style scoped>
</style>
